import { Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { LanguageService } from '../../services/language.service';
import { DialogData } from './DialogData';

@Component({
  selector: 'app-confirmation-dialog2',
  templateUrl: './confirmation-dialog2.component.html',
  styleUrls: ['./confirmation-dialog2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmationDialog2Component implements OnInit {
  data: DialogData;
  lang$: Observable<string>;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialog2Component>,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) data: DialogData) {
    this.data = data;
    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    // observables
    this.lang$ = this.languageService.languageType$;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  @HostListener('window: keyup.esc') onKeyUp() {
    this.onNoClick();
  }
}
